<template>
  <div class="massaction-document-container">
    <div class="modal-header-group">
      <p class="title-text mb-3">Document - Vaccine/PCR</p>
      <svg
        class="close-btn"
        @click="$bvModal.hide('document')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <!-- <p class="compliance-status"></p> -->
    <p class="modal-sub-header">
      <template v-if="documentModel.status">
        <template
          v-if="
            documentModel.status == 'completed' ||
            ((documentModel.status == 'failed' ||
              documentModel.status == 'success') &&
              isOptional)
          "
        >
          {{ $tc("signInOut.complianceCompleted", 2) }}.
        </template>
        <template
          v-else-if="
            documentModel.status == 'success' ||
            (documentModel.status == 'failed' &&
              documentModel.compliance_notes.length > 20)
          "
        >
          {{ $tc("signInOut.complianceCompleted", 1) }}.
        </template>
        <template v-else-if="documentModel.status == 'failed'">
          {{ $tc("signInOut.complianceFailed", 1) }}
        </template>
        <!-- <template v-else-if="documentModel.status == 'completed'">
          Compliance completed.
        </template> -->
      </template>
      <template v-else>{{ $tc("signInOut.complianceFailed", 2) }}</template>
    </p>

    <p class="vaccine-name">
      {{
        isOptional
          ? `${
              documentData.name.charAt(0).toUpperCase() +
              documentData.name.slice(1)
            } (Optional)`
          : documentData.name.charAt(0).toUpperCase() +
            documentData.name.slice(1)
      }}
    </p>

    <!-- FILLIN -->
    <div class="user-infocontainer">
      <p
        class="user-info"
        v-if="
          !isAllAction &&
          documentModel.actionByRole &&
          documentModel.actionByName &&
          documentModel.updatedAt
        "
      >
        {{ getDate(documentModel.updatedAt) }}<b> . </b> By
        {{ documentModel.actionByRole }}
        <strong class="strong-txt"> ({{ documentModel.actionByName }})</strong>
      </p>
    </div>

    <!-- document  -->
    <!-- <div
      v-if="!default_walk_in"
      class="mb-3 d-flex align-items-center document-style"
    > -->

    <template v-if="!isAllAction">
      <multiselect
        v-if="!documentModel.selectedDocument"
        id="document"
        class="protocols-multiselect"
        v-model="documentModel.selectedDocument"
        :options="documentOptions"
        :placeholder="$t('signInOut.selectDocument')"
        :show-labels="false"
        label="value"
        :allowEmpty="true"
        :taggable="true"
        deselectLabel
        @select="updateDocumentDetails"
      />

      <div class="alloverlay-layers" v-if="documentModel.selectedDocument">
        <div class="closing-overlay" v-if="documentModel.selectedDocument">
          <h4 class="overlay-con">
            {{ documentModel.selectedDocument.value }}
          </h4>
          <span class="overlay-closing" @click="clearDocument">
            {{ $t("common.remove") }}
          </span>
        </div>
        <showDocumentDetails :documentDetails="documentDetails" />
      </div>
      <!-- </div> -->
    </template>

    <template v-if="!documentModel.selectedDocument">
      <!-- start:: vaccine-pcr toggle -->
      <b-form-radio-group
        class="checkbox-wrapper"
        v-model="documentModel.vaccine_pcr"
        @change="onVaccinePcrToggle"
      >
        <p v-if="!isAllAction" class="pcr-optional-note">
          {{ upperFirst($t("signInOut.addDocManually")) }}
        </p>
        <div v-if="isPcrEnabled">
          <div
            class="d-flex align-items-center align-content-center vaccine-pcrradio"
          >
            <b-form-radio value="vaccine">{{
              $t("common.doc.vaccine")
            }}</b-form-radio>
            <b-form-radio class="pcr-radio" value="pcr">{{
              $t("common.doc.PCR")
            }}</b-form-radio>
          </div>
        </div>
      </b-form-radio-group>
      <!-- end:: vaccine-pcr toggle -->

      <template v-if="documentModel.vaccine_pcr == 'vaccine'">
        <!-- start:: Vaccine protocol -->
        <span
          class="massaction-document-label"
          v-if="documentModel.vaccine_protocol"
        >
          {{ $t("common.doc.vaccineProtocol") }}
        </span>
        <multiselect
          id="protocols"
          v-model="documentModel.vaccine_protocol"
          class="protocols-multiselect"
          :options="protocolOptions"
          :placeholder="$t('common.doc.vaccineProtocol')"
          :show-labels="false"
          :allowEmpty="true"
          @input="updateComponent"
        />
        <!-- end:: Vaccine protocol -->

        <!-- start:: Vaccine name -->
        <span
          class="massaction-document-label"
          v-if="documentModel.vaccine_name"
        >
          {{ $t("common.doc.vaccineName") }}
        </span>
        <b-form-input
          id="name"
          v-model="documentModel.vaccine_name"
          type="text"
          class="input-style document-input"
          :class="{ 'pt-20': documentModel.vaccine_name }"
          :placeholder="$t('common.doc.vaccineName')"
          maxlength="30"
        ></b-form-input>

        <!-- end:: Vaccine name -->

        <!-- start:: Batch number -->
        <span
          class="massaction-document-label"
          v-if="documentModel.batch_number"
        >
          {{ $t("common.doc.batchNumber") }} ({{
            $t("common.optionalWithBrackets")
          }})
        </span>
        <b-form-input
          :class="{ 'pt-20': documentModel.batch_number }"
          id="number"
          v-model="documentModel.batch_number"
          type="text"
          class="input-style document-input"
          :placeholder="$t('common.doc.batchNumber')"
        ></b-form-input>
        <!-- end:: Vaccine name -->

        <div class="d-flex justify-content-between mb-1">
          <!-- start:: Given date  -->

          <b-form-group>
            <span
              class="massaction-document-date-label"
              v-if="documentModel.vaccine_date_taken"
            >
              {{ $t("common.doc.dateTaken") }}
            </span>
            <VpDatepicker
              v-model="documentModel.vaccine_date_taken"
              :first-day-of-week="1"
              lang="en"
              :placeholder="$t('common.doc.dateTaken')"
              value-type="format"
              format="DD/MM/YYYY"
              :disabledDate="disableDateAfterCurrent"
              :disabled="
                documentModel.selectedDocument &&
                Object.keys(documentModel.selectedDocument).length > 0
              "
            >
              <i slot="icon-calendar">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                    :fill="
                      documentModel.vaccine_date_taken ? '#103F5E' : '#787878'
                    "
                  />
                </svg>
              </i>
            </VpDatepicker>
          </b-form-group>
          <!-- end:: Given date -->

          <!-- start:: Expiry date  -->

          <b-form-group>
            <span
              class="massaction-document-date-label"
              v-if="documentModel.vaccine_expiry_date"
            >
              {{ $t("signInOut.expiryDate") }}
            </span>
            <VpDatepicker
              :class="{
                'is-invalid invalid-date-input':
                  submitted &&
                  $v.documentModel.vaccine_expiry_date.$error &&
                  !isLoading,
              }"
              v-model="documentModel.vaccine_expiry_date"
              :first-day-of-week="1"
              lang="en"
              :placeholder="$t('signInOut.expiryDate')"
              value-type="format"
              format="DD/MM/YYYY"
              :disabledDate="disabledExpiredDate"
              :disabled="$v.documentModel.vaccine_date_taken.$invalid"
            >
              <i slot="icon-calendar">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                    :fill="
                      documentModel.vaccine_date_taken ? '#103F5E' : '#787878'
                    "
                  />
                </svg>
              </i>
            </VpDatepicker>
          </b-form-group>
          <!-- end:: Expiry date  -->
        </div>

        <!-- start:: File upload -->
        <div class="mb-3">
          <div>
            <button
              type="button"
              @click="pickImage"
              class="upload-btn vaccine-upload-btn"
              :class="{
                'file-validation':
                  documentModel.documentFile.err &&
                  !documentModel.documentFile.img,
              }"
            >
              <b-form-file
                accept="image/*"
                id="imagePicker"
                @change="onFileChange"
                class="d-none upload-btn"
                v-model="documentModel.vaccine_pcr_file"
              ></b-form-file>
              <div class="d-flex justify-content-between">
                <p
                  class="mt-3 file-label"
                  :class="{
                    'file-label-img-selected': documentModel.documentFile.img,
                  }"
                >
                  {{ $t("common.doc.vaccineFile") }}
                </p>
                <span
                  class="mt-2 paperclip-icon"
                  v-if="!documentModel.documentFile.img"
                  ><i class="mdi mdi-paperclip mdi-24px"></i
                ></span>
              </div>
            </button>
            <div
              v-if="documentModel.documentFile.img"
              style="position: relative"
              class="remove-file-icon-container"
            >
              <img
                :class="{
                  'img-bg': !documentModel.documentFile.img,
                  'img-file': documentModel.documentFile.img,
                }"
                :src="documentModel.documentFile.img"
              />
              <i
                @click="removeImage()"
                class="mdi mdi-delete mdi-24px remove-file-icon text-center"
              >
              </i>
            </div>

            <div
              class="file-note-text mt-1"
              v-if="
                !documentModel.documentFile.err &&
                !documentModel.documentFile.img
              "
            >
              <b>{{ $t("common.notes.note") }}: </b
              >{{ $t("common.notes.uploadImgNoteDoc") }}
            </div>
            <p class="file-err-text mt-1" v-if="documentModel.documentFile.err">
              {{ $t("common.notes.uploadImgNoteDoc") }}
            </p>
          </div>
        </div>
        <!-- end:: File upload -->
      </template>
      <template v-else-if="documentModel.vaccine_pcr == 'pcr'">
        <!-- start :: PCR result -->
        <span class="massaction-document-label" v-if="documentModel.pcr_result">
          {{ $t("signInOut.pcrResult") }}
        </span>
        <multiselect
          class="protocols-multiselect mb-3"
          v-model="documentModel.pcr_result"
          :placeholder="$t('signInOut.pcrResult')"
          temperature-label
          id="pcr"
          :options="pcrOptions"
          :show-labels="false"
          label="label"
          track-by="value"
          :allowEmpty="true"
        />
        <!-- end :: PCR result -->

        <div class="d-flex justify-content-between">
          <b-form-group>
            <span
              class="massaction-document-date-label"
              v-if="documentModel.pcr_date_taken"
            >
              Date Taken
            </span>
            <VpDatepicker
              v-model="documentModel.pcr_date_taken"
              :class="{
                'is-invalid invalid-date-input':
                  submitted &&
                  $v.documentModel.pcr_date_taken.$error &&
                  !isLoading,
              }"
              :first-day-of-week="1"
              lang="en"
              :placeholder="$t('common.doc.dateTaken')"
              value-type="format"
              format="DD/MM/YYYY"
              :disabledDate="disableDateAfterCurrent"
            >
              <i slot="icon-calendar">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                    :fill="documentModel.pcr_date_taken ? '#103F5E' : '#787878'"
                  />
                </svg>
              </i>
            </VpDatepicker>
          </b-form-group>

          <!-- start:: PCR file upload-->
          <div class="mb-3">
            <button
              type="button"
              @click="pickImage"
              class="upload-btn pcr-upload-file"
              :class="{
                'file-validation':
                  documentModel.documentFile.err &&
                  !documentModel.documentFile.img,
              }"
            >
              <b-form-file
                accept="image/*"
                id="imagePicker"
                @change="onFileChange"
                v-model="documentModel.vaccine_pcr_file"
                class="d-none upload-btn"
              ></b-form-file>
              <div class="d-flex justify-content-between">
                <p
                  class="mt-3 file-label"
                  :class="{
                    'file-label-img-selected': documentModel.documentFile.img,
                  }"
                >
                  {{ $t("signInOut.pcrFile") }}
                </p>
                <span
                  class="mt-2 paperclip-icon pcr-upload-btn"
                  v-if="!documentModel.documentFile.img"
                  ><i class="mdi mdi-paperclip mdi-24px"></i
                ></span>
              </div>
            </button>
            <div
              v-if="documentModel.documentFile.img"
              style="position: relative"
            >
              <img
                :class="{
                  'img-bg': !documentModel.documentFile.img,
                  'img-file': documentModel.documentFile.img,
                }"
                :src="documentModel.documentFile.img"
              />
              <i
                @click="removeImage()"
                class="mdi mdi-delete mdi-24px remove-pcr-file-icon"
              >
              </i>
            </div>

            <div
              class="file-note-text mt-1"
              v-if="
                !documentModel.documentFile.err &&
                !documentModel.documentFile.img
              "
            >
              <b>{{ $t("common.notes.note") }}: </b>
              {{ $t("common.notes.uploadImgNoteDoc") }}
            </div>
            <p class="file-err-text mt-1" v-if="documentModel.documentFile.err">
              {{ $t("common.notes.uploadImgNoteDoc") }}
            </p>
          </div>
          <!-- end:: PCR file upload-->
        </div>
      </template>

      <!-- start:: Document notes -->
      <span
        class="massaction-document-label"
        v-if="documentModel.document_notes && !showDocumentNoteLabel"
        >{{ $t("common.doc.documentNotes") }}
        {{ $t("common.optionalWithBrackets") }}</span
      >
      <b-form-textarea
        class="input-style mb-2 notes document-notes"
        :class="{
          'remove-padding':
            documentModel.document_notes && showDocumentNoteLabel,
          'top-padding': documentModel.document_notes && !showDocumentNoteLabel,
        }"
        type="text"
        :placeholder="`${$t('common.doc.documentNotes')} ${$t(
          'common.optionalWithBrackets'
        )}`"
        rows="3"
        no-resize
        v-model="documentModel.document_notes"
        maxlength="255"
      ></b-form-textarea>
      <!-- end:: Document notes -->
    </template>

    <hr class="my-4" />
    <!-- start:: Compliance notes -->
    <p class="compliance-document-note">
      Note: {{ $t("signInOut.mandatoryNotes") }}
    </p>
    <span
      class="massaction-document-label"
      v-if="documentModel.compliance_notes && !showComplianceNoteLabel"
      >{{ $tc("signInOut.complianceNote", 1) }}
    </span>

    <b-form-textarea
      class="input-style mb-2 notes compliance-notes"
      :class="{
        'remove-padding':
          documentModel.compliance_notes && showComplianceNoteLabel,
        'top-padding':
          documentModel.compliance_notes && !showComplianceNoteLabel,
      }"
      type="text"
      :placeholder="$tc('signInOut.complianceNote', 1)"
      rows="3"
      no-resize
      maxlength="255"
      v-model="documentModel.compliance_notes"
    ></b-form-textarea>
    <!-- end:: Compliance notes -->
    <button
      @click="onSubmit"
      :disabled="$v.$invalid || (documentModel.isDirty && !enableButton)"
      class="document-submit-btn"
    >
      {{ documentModel.isDirty ? $t("common.update") : $t("signInOut.fillIn") }}
    </button>
  </div>
</template>

<script>
import requiredIf from "vuelidate/lib/validators/requiredIf";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import moment from "moment";
import showDocumentDetails from "../../../../components/reports/showDocumentDetails/showDocumentDetails.vue";
// eslint-disable-next-line no-unused-vars
import { upperFirst } from "lodash";

export default {
  components: { Multiselect, showDocumentDetails },
  // props: [],
  data() {
    return {
      documentDetails: {},
      enableButton: false,
      componentIsTouched: false,
      isAllAction: false,
      showDocumentNoteLabel: true,
      showComplianceNoteLabel: true,
      isOptional: false,
      documentOptions: [],
      isPcrEnabled: true,
      submitted: false,
      documentData: {},
      documentModel: {},
      protocolOptions: [
        "EU Digital COVID Certificate",
        "NHS (Domestic/International)",
        "Smart Health Card (SHC)",
        "NYS Excelsior Pass & NYS Excelsior Pass Plus",
      ],
      pcrOptions: [
        { label: "Negative", value: false },
        { label: "Positive", value: true },
      ],
      isDocumentFileRemoved: false,
      // documentFile: {
      //   img: "",
      // },
    };
  },
  validations: {
    documentModel: {
      selectedDocument: {},
      vaccine_pcr: {},
      vaccine_protocol: {
        required: requiredIf(function (vaccine_pcr) {
          return (
            vaccine_pcr.vaccine_pcr == "vaccine" &&
            !vaccine_pcr.selectedDocument
          );
        }),
      },
      vaccine_name: {
        required: requiredIf(function (vaccine_pcr) {
          return (
            vaccine_pcr.vaccine_pcr == "vaccine" &&
            !vaccine_pcr.selectedDocument
          );
        }),
      },
      //   batch_number: {},
      vaccine_date_taken: {
        required: requiredIf(function (vaccine_pcr) {
          return (
            vaccine_pcr.vaccine_pcr == "vaccine" &&
            !vaccine_pcr.selectedDocument
          );
        }),
      },
      vaccine_expiry_date: {
        required: requiredIf(function (vaccine_pcr) {
          return (
            vaccine_pcr.vaccine_pcr == "vaccine" &&
            !vaccine_pcr.selectedDocument
          );
        }),
      },
      vaccine_pcr_file: {
        required: requiredIf(function (vaccine_pcr) {
          return !vaccine_pcr.selectedDocument;
        }),
      },

      pcr_result: {
        required: requiredIf(function (vaccine_pcr) {
          return (
            vaccine_pcr.vaccine_pcr == "pcr" && !vaccine_pcr.selectedDocument
          );
        }),
        mustBePositive: (result, vModel) => {
          if (vModel.vaccine_pcr == "pcr" && !vModel.selectedDocument) {
            return (
              !result?.value ||
              (result?.value && vModel.compliance_notes?.length >= 20)
            );
          } else {
            return true;
          }
        },
      },
      pcr_date_taken: {
        required: requiredIf(function (vaccine_pcr) {
          return (
            vaccine_pcr.vaccine_pcr == "pcr" && !vaccine_pcr.selectedDocument
          );
        }),
      },

      document_notes: {},
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  watch: {
    documentModel: {
      handler() {
        if (this.componentIsTouched) {
          this.enableButton = true;
        }
        this.componentIsTouched = true;
      },
      deep: true,
    },
    "documentModel.compliance_notes"() {
      let textArea = document.querySelector(".compliance-notes");
      this.showComplianceNoteLabel =
        textArea?.scrollHeight > textArea?.clientHeight + 3;
    },
    "documentModel.document_notes"() {
      let textArea = document.querySelector(".document-notes");
      this.showDocumentNoteLabel =
        textArea?.scrollHeight > textArea?.clientHeight + 3;
    },
  },
  methods: {
    onSubmit() {
      this.submitted = true;
      this.documentModel.isDirty = true;
      this.documentModel.allAction = false;
      this.documentModel.status = "success";
      if (this.isAllAction) {
        this.$emit("massActionDocumentSubmit", this.documentModel);
      } else {
        this.$emit("documentSubmit", this.documentModel);
      }
      this.$bvModal.hide("document");
    },
    onVaccinePcrToggle(currentValue) {
      this.removeImage();
      this.documentModel.compliance_notes = "";
      this.documentModel.document_notes = "";
      if (currentValue == "pcr") {
        this.documentModel.vaccine_name = "";
        this.documentModel.vaccine_protocol = null;
        this.documentModel.batch_number = "";
        this.documentModel.vaccine_date_taken = "";
        this.documentModel.vaccine_expiry_date = "";
      } else {
        this.documentModel.pcr_result = "";
        this.documentModel.pcr_date_taken = "";
      }
    },
    getDate(date) {
      return moment
        .utc(date)
        .tz(moment.tz.guess())
        .format("DD/MM/YYYY - h:mm A");
    },
    pickImage() {
      document.getElementById("imagePicker").click();
    },
    onFileChange(e) {
      this.documentModel.documentFile.err = false;
      let file = e.target.files[0];
      if (!file || file.type.indexOf("image/") !== 0) return;
      const extensionType = file.type.split("/")[1];
      if (extensionType != "png" && extensionType != "jpeg") {
        return (this.documentModel.documentFile.err = true);
      }
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        let newImg = new Image();
        newImg.onload = () => {
          if (file.size > 3097152) {
            return (this.documentModel.documentFile.err = true);
          }
          this.documentModel.documentFile.img = URL.createObjectURL(file);
          this.isDocumentFileRemoved = false;
        };
        newImg.src = evt.target.result;
        this.documentModel.vaccine_pcr_file = file;
      };
      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
    removeImage() {
      this.documentModel.documentFile.img = "";
      this.isDocumentFileRemoved = true;
      this.documentModel.vaccine_pcr_file = null;
    },

    updateDocumentDetails(document) {
      // this.documentModel.compliance_notes = "";
      // this.documentModel.document_notes = "";
      const certificateModel =
        document?.metadata?.certificateModel || document.certificateModel;
      // console.log("type", document.type);
      // console.log("protocol", document.protocol);
      if (document.type == "covid_vaccine") {
        this.documentDetails = {
          "Vaccine Protocol": document?.metadata?.protocol || document.protocol,
          // document?.metadata?.protocol != "manual"
          //   ? document?.metadata?.protocol
          //   : null,
          "Vaccine Name": certificateModel?.vaccinations[0]?.vaccine,
          "Batch Number": certificateModel?.vaccinations[0]?.batchNumber,
          "Date Taken": certificateModel?.vaccinations[0]?.dateOfVaccination
            ? moment(
                certificateModel.vaccinations[0].dateOfVaccination,
                "DD/MM/YYYY"
              ).format("DD/MM/YYYY")
            : null,
          "Expiry Date": document.expiry_date
            ? moment(document.expiry_date, "YYYY-MM-DD hh:mm:ss").format(
                "DD/MM/YYYY"
              )
            : moment(
                document.greenCertificatData.expirationTime,
                "YYYY-MM-DD hh:mm:ss"
              ).format("DD/MM/YYYY"),
          "Vaccine File": document.metadata?.fileAttach || document.fileAttach,
        };
      } else {
        this.documentDetails = {
          "PCR Result": document.name,
          "Date Taken": certificateModel.tests[0]?.dateTimeOfTestResult
            ? moment(
                certificateModel.tests[0].dateTimeOfTestResult,
                "YYYY-MM-DD hh:mm:ss"
              ).format("DD/MM/YYYY")
            : null,
          "Vaccine File": document.metadata?.fileAttach || document.fileAttach,
        };
      }
    },
    clearDocument() {
      this.documentModel.selectedDocument = null;
    },
    updateComponent() {
      this.$forceUpdate();
    },
    disableDateAfterCurrent(date) {
      return date > new Date();
    },
    disabledExpiredDate(date) {
      const givenDate = new Date();
      givenDate.setHours(0, 0, 0, 0);
      return date <= givenDate;
    },
  },
  beforeMount() {
    this.isAllAction = this.getModalInfo.allAction;

    this.documentData = JSON.parse(
      JSON.stringify(this.getModalInfo.complianceDocument[0])
    );
    this.documentModel = JSON.parse(
      JSON.stringify(this.getModalInfo.documentModel)
    );

    this.isPcrEnabled = this.documentData.form_metadata?.data[0]?.pcr
      ? true
      : false;
    this.isOptional = this.getModalInfo.isOptional;

    this.documentOptions = JSON.parse(
      JSON.stringify(this.getModalInfo.user_documents)
    ).map((item) => {
      if (item.type == "covid_pcr") {
        const {
          metadata: {
            certificateModel: { tests },
          },
        } = item;
        return {
          id: item.id,
          name:
            tests[0].testResult == "Not detected"
              ? "Negative PCR"
              : "Positive PCR",
          date: tests[0].dateTimeOfTestResult,
          value: `${
            tests[0].testResult == "Not detected"
              ? "Negative PCR"
              : "Positive PCR"
          }  (${tests[0].dateTimeOfTestResult.substring(0, 10)})`,
          ...item,
        };
      } else if (item?.type == "covid_vaccine") {
        const vaccinations = item?.metadata?.certificateModel?.vaccinations;
        const expirationTime =
          item?.metadata?.greenCertificatData?.expirationTime;
        return {
          id: item.id,
          name:
            vaccinations &&
            vaccinations[0]?.vaccine &&
            vaccinations[0]?.vaccine?.length
              ? vaccinations[0]?.vaccine
              : "Vaccine",
          date: expirationTime ?? "N/A",
          value: `${
            vaccinations &&
            vaccinations[0]?.vaccine &&
            vaccinations[0]?.vaccine?.length
              ? vaccinations[0]?.vaccine
              : "Vaccine"
          }  (${
            expirationTime == "Invalid date" || !expirationTime
              ? "N/A"
              : expirationTime.substring(0, 10)
          })`,
          ...item,
        };
      }
    });
    //Parse selected document if compliance is perviously filled in
    if (
      this.documentModel.isFilledInCopmpliance ||
      this.documentModel.selectedDocument
    ) {
      let item = this.documentModel.selectedDocument;
      // console.log(item);
      //if submitted PCR
      if (item?.protocol == "undefined" || item?.type == "covid_pcr") {
        let tests =
          item.metadata?.certificateModel?.tests ||
          item.certificateModel?.tests;

        item = {
          id: item.id,
          name:
            tests[0].testResult == "Not detected"
              ? "Negative PCR"
              : "Positive PCR",
          date: tests[0].dateTimeOfTestResult,
          value: `${
            tests[0].testResult == "Not detected"
              ? "Negative PCR"
              : "Positive PCR"
          }  (${tests[0].dateTimeOfTestResult.substring(0, 10)})`,
          ...item,
        };
      } else {
        //if submitted Vaccine
        const vaccinations =
          item?.metadata?.certificateModel?.vaccinations ||
          item?.certificateModel?.vaccinations;
        const expirationTime =
          item?.metadata?.greenCertificatData?.expirationTime ||
          item?.greenCertificatData?.expirationTime;
        item = {
          id: item.id,
          name:
            vaccinations &&
            vaccinations[0]?.vaccine &&
            vaccinations[0]?.vaccine?.length
              ? vaccinations[0]?.vaccine
              : "Vaccine",
          date: expirationTime ?? "N/A",
          value: `${
            vaccinations &&
            vaccinations[0]?.vaccine &&
            vaccinations[0]?.vaccine?.length
              ? vaccinations[0]?.vaccine
              : "Vaccine"
          }  (${
            expirationTime == "Invalid date" || !expirationTime
              ? "N/A"
              : expirationTime.substring(0, 10)
          })`,
          ...item,
        };
      }

      this.documentModel.selectedDocument = item;
      this.documentModel.compliance_notes =
        this.documentModel.filledInComplianceNotes;

      this.updateDocumentDetails(this.documentModel.selectedDocument);
    }
  },
};
</script>

<style lang="scss">
.massaction-document-container {
  .mdi-24px.remove-pcr-file-icon:before {
    margin-inline-start: 14px !important;
  }

  .remove-pcr-file-icon {
    position: absolute;
    z-index: 55;
    width: 51px;
    height: 39px;
    border-radius: 5px;
    bottom: 6px;
    inset-inline-start: 141px;
    opacity: 0;
    color: #ffffff;
  }
  .remove-pcr-file-icon:hover {
    background-color: #666666;
    opacity: 0.8 !important;
    display: block;
  }
  .input-style {
    background-color: #f2f2f2;
    border-radius: 4px;
    border: 0;

    font-size: 16px;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
  }
  .mx-input {
    width: 190px !important;
    height: 55px !important;
    background: #f2f2f2 !important;
    border: 0 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 17px !important;
    letter-spacing: 0.25px;
    color: #000000 !important;
    padding-inline-start: 20px !important;
  }
  .vaccine-date {
    width: 190px !important;
    height: 48px;

    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.8;
    ::placeholder {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: #787878;
    }
  }
  .document-submit-btn {
    height: 44px;
    width: 395px;
    inset-inline-start: 0px;
    top: 0px;
    border-radius: 22px;
    background-color: #103f5e;
    color: #ffffff;
    border: 0;
    margin-top: 15px;
  }
  .document-submit-btn:disabled {
    background-color: #96abb8;
  }
  .vaccine-pcrradio {
    margin-inline-start: 13px;
    margin-bottom: 39px;
    label.custom-control-label {
      position: relative;
      padding-inline-start: 20px;
      padding-top: 0px !important;

      font-weight: 400;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: rgba(96, 96, 96, 0.87);
      opacity: 0.8;
    }
    .custom-control-input:checked ~ .custom-control-label::after {
      border-radius: 50%;
      background-image: none !important;
      width: 12px !important;
      height: 12px !important;
      background: #103f5e !important;
      position: absolute;
      top: 5.7px;
      inset-inline-start: -20.2px;
    }
    .custom-control-input:checked ~ .custom-control-label {
      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      /* identical to box height, or 106% */

      letter-spacing: 0.25px;

      color: #103f5e !important;

      opacity: 0.8 !important;
    }
    .custom-control-label::before {
      border-radius: 50%;
      position: absolute;
      width: 20px !important;
      height: 20px !important;
      background: #c7c7c7 !important;
      border-color: #c7c7c7 !important;
      opacity: 0.3 !important;
    }
    label.custom-control-label {
      padding-inline-start: 20px;
    }
    .pcr-radio.custom-control.custom-radio {
      margin-inline-start: 56px;
    }
  }
  .modal-header-group {
    display: flex;
    justify-content: space-between;
    width: 310px;
    text-align: center;
    margin-top: 15px;
    margin-inline-end: auto;
    margin-bottom: 38px;
    margin-inline-start: 110px;
    .title-text {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      color: #000000;
    }
  }
  .compliance-status {
    text-align: center;
    color: #666666;

    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
  }
  .vaccine-name {
    color: #939393;

    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: start;
    margin: 30px auto;
  }
  .pcr-optional-note {
    margin: 30px auto;
    text-align: center;
    color: #666666;

    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  .compliance-document-note {
    font-size: 14px;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #939393;
    margin: 15px 20px;
  }
  .document-input {
    height: 55px;
    margin-bottom: 15px;
    padding-inline-start: 20px;
    // margin-top:5px;
  }

  .document-input::placeholder {
    font-size: 16px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: rgba(96, 96, 96, 0.87);
  }
  .vaccine-upload-btn {
    width: 190px;
  }
  .pcr-upload-file {
    width: 190px;
    margin-inline-start: 10px;
  }
  .massaction-document-label,
  .massaction-document-date-label {
    position: absolute;
    margin-inline-start: 20px;
    margin-top: 9px;
    z-index: 2;
    color: #103f5e;
    font-size: 12px;
    opacity: 0.8;

    font-weight: 700;

    line-height: 17px;
    letter-spacing: 0.25px;
    opacity: 0.8;
  }
  .massaction-document-date-label {
    margin-top: 5px;
  }
  .protocols-multiselect .multiselect__tags,
  .protocols-multiselect .multiselect__single {
    margin-top: 8px;
    margin-inline-start: -2px;
  }
  .protocols-multiselect .multiselect__placeholder {
    padding-inline-start: 10px;
  }
  .pt-20 {
    padding-top: 20px;
  }
  .file-label {
    padding-inline-start: 10px;
  }
  .mx-datepicker .mx-icon-calendar,
  .mx-input-wrapper .mx-icon-clear {
    margin-inline-end: 10px;
  }
  .remove-padding {
    padding-top: 12px !important;
  }

  .document-notes,
  .compliance-notes {
    padding-inline-start: 20px !important;
    height: auto;
    padding: 15px 0;
  }
  .img-file {
    inset-inline-start: 135px !important;
  }
  .remove-pcr-file-icon,
  .remove-file-icon {
    inset-inline-start: 135px !important;
    height: 39.5px !important;
    width: 50.5px !important;
  }
  .mdi-24px.mdi-set,
  .mdi-24px.mdi:before {
    display: block;
    margin-top: 2px;
  }
  .paperclip-icon {
    bottom: 8px !important;
  }
  .modal-sub-header {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #666666;
    margin-bottom: 30px;
  }
  .remove-padding {
    padding-top: -10px !important;
  }
  .top-padding {
    padding-top: 26px !important;
  }
  .multiselect__tags {
    height: 55px !important;
    background: #f2f2f2 !important;
    border-radius: 4px !important;
    border: none !important;
    display: flex;
    align-items: center;
    .multiselect__single {
      background: #f2f2f2 !important;

      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      width: 327px !important;
      letter-spacing: 0.25px;
      color: rgba(0, 0, 0, 0.87);

      opacity: 0.8;
    }
    .multiselect__placeholder {
      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      padding-inline-start: 10px !important;

      letter-spacing: 0.25px;
      opacity: 0.8;
      color: rgba(96, 96, 96, 0.87) !important;
    }
  }
  .protocols-multiselect {
    margin-bottom: 15px;
    .multiselect__select {
      z-index: 5;
      margin-top: 5px;
    }
    .multiselect__tags {
      border: 0px !important;
      height: 55px;
      .multiselect__input {
        background-color: #f2f2f2 !important;
      }
    }
    .multiselect__single {
      position: relative !important;
      top: 2px !important;
      inset-inline-start: 12px;

      font-size: 16px !important;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
      width: 327px !important;
    }
    .multiselect__tags,
    .multiselect__single {
      background-color: #f2f2f2 !important;
      border-radius: 4px;
    }
    .multiselect__placeholder {
      margin-bottom: 10px !important;
      padding-inline-start: 10px !important;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.25px;
    }
  }
  .file-note-text {
    width: 200px;

    font-weight: 700;
    font-size: 12px !important;
    line-height: 17px;
    text-align: start;

    letter-spacing: 0.25px;

    max-width: 280px !important;

    color: #939393;

    opacity: 0.8;
  }
  .upload-btn {
    background-color: #f2f2f2;
    color: #000000;
    width: 200px;
    height: 55px;
    border-radius: 4px;
    border: 0;
  }
  .remove-file-icon {
    position: absolute;
    z-index: 5;
    width: 51px;
    height: 39px;
    border-radius: 5px;
    bottom: 6px;
    inset-inline-start: 143px;
    opacity: 0;
    color: #ffffff;
  }
  .remove-file-icon:hover {
    background-color: #666666;
    opacity: 0.8 !important;
    display: block;
  }
  .file-note-text {
    width: 200px;

    font-weight: 700;
    font-size: 12px !important;
    line-height: 17px;
    text-align: start;

    letter-spacing: 0.25px;

    max-width: 280px !important;

    color: #939393;

    opacity: 0.8;
  }

  .file-label {
    margin-inline-start: 15px;
    margin-bottom: 10px;
  }
  .file-label-img-selected {
    color: #3d637c;
    margin-bottom: 15px;
  }
  .img-bg {
    // position: absolute;
    z-index: 4;
    width: 50.5px;
    height: 38.4px;
    border-radius: 5px !important;
    bottom: 7px;
    // inset-inline-start: 143px;
    border: 0px;
  }
  .img-file {
    position: absolute;
    z-index: 4;
    width: 51px;
    height: 38.4px;
    border-radius: 5px !important;
    bottom: 6px;
    inset-inline-start: 143px;
    border: 0px;
  }
  .closing-overlay {
    width: 415px;
    display: flex;
    height: 55px;
    align-items: center;
    background: #f2f2f2;
    justify-content: space-between;
    border-radius: 4px;
    h4.overlay-con {
      padding-inline-start: 20px;

      font-weight: 700;
      font-size: 16px;
      margin-top: 10px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: #103f5e;
    }
    span.overlay-closing {
      padding-inline-end: 16px;
      font-size: 16px;
      font-weight: 600;
      line-height: 17px;
      letter-spacing: 0.25px;
      text-align: start;
      color: #f46a6a;
      cursor: pointer;
    }
  }
  .document-notes-container {
    width: 415px;
  }
}
</style>
